import React from "react";

import { Props } from "./types";
import { sort } from "./utils";

function Sort<Data extends Array<any>>(props: Props<Data>) {
  return (
    <React.Fragment>
      {props.children(sort(props.sort, props.data, props.extractCriteria))}
    </React.Fragment>
  );
}

export { Sort, sort };
